import type HighchartsReact from 'highcharts-react-official'

import 'highcharts/css/stocktools/gui.css'
import 'highcharts/css/annotations/popup.css'

import { addCustomCss } from './utils/options'

export type ChartProps = HighchartsReact.Props

export * from './charts'
export { ExportContextProvider, useExport } from './contexts/ExportContext'
export { WORLD_GEO_JSON } from './utils/worldmap'

export type { Customizations } from './utils/customizations'
export * from './utils/export'

addCustomCss()
